import clsx from "clsx";
import type { NavItem } from "@/lib/nav";
import type { NavBadges } from "@/navigation/useNavBadges";

interface NavBadgeProps {
  item: NavItem;
  badges: NavBadges;
  className?: string;
  /** Aktiver Navigationspunkt – Badge behält Kontrast statt halbtransparentem Overlay */
  active?: boolean;
}

export function NavBadge({ item, badges, className, active = false }: NavBadgeProps) {
  if (!item.badgeKey) return null;
  const count = badges[item.badgeKey];
  if (!count || count <= 0) return null;

  const toneClass =
    item.badgeKey === "inquiriesOpen"
      ? active
        ? "bg-status-orange text-white ring-1 ring-white/30"
        : "bg-status-orange text-white"
      : item.badgeKey === "chargeRulesRequiredOpen"
        ? active
          ? "bg-status-red text-white ring-1 ring-white/30"
          : "bg-status-red text-white"
        : active
          ? "bg-status-red text-white ring-1 ring-white/30"
          : "bg-status-red text-white";

  const defaultClass = clsx(
    "inline-flex min-h-[1.125rem] min-w-[1.25rem] items-center justify-center rounded-full px-1.5 py-0.5 text-[0.6875rem] font-bold leading-none tabular-nums shadow-sm",
    toneClass,
  );

  return (
    <span
      className={className ?? defaultClass}
      aria-label={
        item.badgeKey === "inquiriesOpen"
          ? `${count} neue Anfragen`
          : item.badgeKey === "chargeRulesRequiredOpen"
            ? `${count} offene Pflichtzuordnungen`
            : item.badgeKey === "ticketsOpen"
              ? `${count} offene Tickets`
              : `${count} offen`
      }
    >
      {count > 99 ? "99+" : count}
    </span>
  );
}
